import { Menu, ToggleButton, ToggleButtonGroup, Typography, type MenuProps } from "@mui/material";
import { useState } from "react";
import { type IStatus } from "src/constants";
import { StatusGroupToggleButton } from "./StatusGroupToggleButton";
import { StatusToggleButton } from "./StatusToggleButton";

interface Props<T> {
  value: T;
  statuses: IStatus[];
  selectedStatusIds: number[];
  menuProps?: Partial<MenuProps>;
  activeStatusFilter: (status: IStatus) => boolean;
  closedStatusFilter: (status: IStatus) => boolean;
  onStatusSelected: (selectedStatusIds: number[]) => void;
}

const ToggleButtonStatusSubmenu = <T extends number | string>(props: Props<T>) => {
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);

  return (
    <>
      <ToggleButton value={props.value} onClick={(e) => setMenuAnchor(e.currentTarget)}>
        <Typography>{`Status ${props.selectedStatusIds.length > 0 ? `(${props.selectedStatusIds.length})` : ""}`}</Typography>
      </ToggleButton>

      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        anchorOrigin={{
          horizontal: "right",
          vertical: "top",
        }}
        transformOrigin={{
          horizontal: "left",
          vertical: "top",
        }}
        slotProps={{ paper: { sx: { minWidth: 200 } } }}
        {...props.menuProps}
      >
        <ToggleButtonGroup
          value={props.selectedStatusIds}
          orientation="vertical"
          variant="menu"
          onChange={(_, statusIds: number[]) => props.onStatusSelected(statusIds)}
          sx={{ minWidth: "100%" }}
        >
          <StatusGroupToggleButton
            label="All Active"
            selectedStatusIds={props.selectedStatusIds}
            childStatusIds={props.statuses.filter(props.activeStatusFilter).map((x) => x.id)}
            onClick={(selected) => props.onStatusSelected(selected)}
          />

          {props.statuses.filter(props.activeStatusFilter).map((status) => (
            <StatusToggleButton
              key={status.id}
              status={status}
              selected={props.selectedStatusIds.includes(status.id)}
            />
          ))}

          <StatusGroupToggleButton
            label="All Closed"
            selectedStatusIds={props.selectedStatusIds}
            childStatusIds={props.statuses.filter(props.closedStatusFilter).map((x) => x.id)}
            onClick={(selected) => props.onStatusSelected(selected)}
            sx={{ mt: "20px !important" }}
          />

          {props.statuses.filter(props.closedStatusFilter).map((status) => (
            <StatusToggleButton
              key={status.id}
              status={status}
              selected={props.selectedStatusIds.includes(status.id)}
            />
          ))}
        </ToggleButtonGroup>
      </Menu>
    </>
  );
};

export { ToggleButtonStatusSubmenu };
